import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { permissionConstants } from './constants';

export interface TokenClaim {
  aud: string;
  iss: string;
  iat: number;
  nbf: number;
  exp: number;
  name: string;
  oid: string;
  preferred_username: string;
}

@Injectable({
  providedIn: 'root',
})
export class TokenClaimsService {
  tokenClaims$!: TokenClaim;
  isEnergyCreditAdmin = false;
  canAccessEC = false;
  isAdmin = false;
  isSupport = false;
  //QBuilt
  canAccessQBuilt = false;
  private _idToken = '';
  canAccessHomeOfficeAdmin = false;

  constructor(private msalService: MsalService) {}

  setTokenClaim(idTokenClaims: any): void {
    this.tokenClaims$ = idTokenClaims as TokenClaim;
  }

  setPermissions(tokenClaims: any): void {
    const roles: string[] = tokenClaims.roles || [];

    this.isSupport = roles.some((x) => x === permissionConstants.support);
    this.isAdmin = roles.some((x) => x === permissionConstants.siteAdmin);

    this.canAccessEC =
      this.isAdmin ||
      this.isSupport ||
      roles.some((x) => permissionConstants.energyCredits.includes(x));

    this.isEnergyCreditAdmin =
      this.isAdmin || roles.some((x) => x === 'EnergyCreditsAdmin');

    this.canAccessQBuilt = roles.some((x: string) =>
      permissionConstants.qBuilt.includes(x),
    );

    this.canAccessHomeOfficeAdmin = roles.some(
      (x: string) => x == permissionConstants.homeOfficeAdmin,
    );
  }

  hasRole(role: string): boolean {
    return (
      (this.msalService.instance
        .getAllAccounts()[0]
        ?.idTokenClaims?.roles?.indexOf(role) ?? -1) > -1
    );
  }

  setIdToken(token: string): void {
    this._idToken = token;
  }

  getIdToken(): string {
    this.setIdToken(this.msalService.instance.getAllAccounts()[0].idToken!);
    return this._idToken;
  }
}
